// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__2jAc3","content":"carousel_content__3z2OT","control":"carousel_control__3E-AP"};